import React, { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Typeahead } from "react-bootstrap-typeahead";

import { useGetTimezones } from "api/queries/common/useGetTimezones";
import { ReactComponent as ChevronDown } from "assets/images/iconsV2/chevron-down.svg";
import { Controller, useFormContext } from "react-hook-form";

const timezoneDataSelector = (data: any) =>
  data.map((item: any) => ({
    value: item.value,
    label: item.name,
  }));

type ProofOfPickupDeliveryTimezoneProps = {
  country: string;
  name: string;
};

const ProofOfPickupDeliveryTimezone: FC<ProofOfPickupDeliveryTimezoneProps> = function (props) {
  const { country, name } = props;
  const intl = useIntl();
  const { watch, control } = useFormContext();
  const { data: timezoneData }: any = useGetTimezones(
    { ...(country && { country_name: country }) },
    { select: timezoneDataSelector },
  );
  const deliveryTimezone = watch(name);
  const selectedValue = timezoneData?.find(
    (item: any) => item.value?.toString()?.toLowerCase() === deliveryTimezone?.toString()?.toLowerCase(),
  );

  return (
    <div className="pod-container__timezone-container">
      <div className="text-sm text-secondary-v2 font-medium mb-sm">
        {name === "delivery_timezone" ? (
          <FormattedMessage
            id="components.molecules.top-nav.timezoneOfDelivery"
            defaultMessage="Timezone of delivery location"
          />
        ) : (
          <FormattedMessage
            id="components.molecules.top-nav.timezoneOfPickup"
            defaultMessage="Timezone of pickup location"
          />
        )}
        <span className="text-danger ml-1">*</span>
      </div>
      <Controller
        control={control}
        rules={{ required: true }}
        name={name}
        render={({ field: { onChange, value, ...rest }, fieldState: { error } }) => (
          <>
            <Typeahead
              id="proof-of-delivery-timezone"
              labelKey={"label" as any}
              inputProps={{ className: error ? "invalid-input" : "" }}
              onChange={(e) => {
                onChange(e?.[0]?.value || "");
              }}
              options={timezoneData || []}
              placeholder="Select"
              selected={selectedValue ? [selectedValue] : []}
              paginationText={intl.formatMessage({
                id: "components.searchSelect.paginationText",
                defaultMessage: "More...",
              })}
              {...rest}
            >
              <div className="pod-container__timezone-container-chevron">
                <ChevronDown />
              </div>
            </Typeahead>
            {error && (
              <div className="d-block text-sm invalid-feedback">
                {error?.message ? (
                  error.message
                ) : (
                  <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
                )}
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};

export default ProofOfPickupDeliveryTimezone;
